import React from 'react';
export var defaultFocusMenuListContext = {
  shouldFocusChild: false,
  expandedId: null,
  selectedId: null,
  dispatch: undefined,
  mouse: true,
  menuRef: null
};
export var MenuListContext = React.createContext(defaultFocusMenuListContext);